import { APP_INITIALIZER, EnvironmentProviders, makeEnvironmentProviders, Provider } from '@angular/core';
import { definePreset, palette } from '@primeng/themes';
import Lara from '@primeng/themes/lara';
import { providePrimeNG } from 'primeng/config';
import { UIConfig } from '../../config';
import { ThemeManager } from './services/theme.service';

const themeServices = [ThemeManager];

export const provideTheme: (config: Partial<UIConfig>) => EnvironmentProviders = (config) => {
    const primaryColor =
        config && config.vars && config.vars['primary-color'] ? config.vars['primary-color'] : '#3b82f6';
    const primary = palette(primaryColor);

    const secondaryColor =
        config && config.vars && config.vars['secondary-color'] ? config.vars['secondary-color'] : '#3b82f6';
    const secondary = palette(secondaryColor);

    const EngPreset = definePreset(Lara, {
        primitive: {
            primary,
            secondary
        },
        semantic: {
            primary
        }
    });

    const providers: Array<EnvironmentProviders | Provider> = [
        ...themeServices,
        {
            provide: APP_INITIALIZER,
            useFactory: (themeManager: ThemeManager) => () => {
                themeManager.startup();
            },
            deps: [ThemeManager],
            multi: true
        },
        providePrimeNG({
            theme: {
                preset: EngPreset,
                options: {
                    darkModeSelector: false
                }
            },
            translation: {
                dayNames: ['Domenica', 'Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato'],
                dayNamesShort: ['Dom', 'Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab'],
                dayNamesMin: ['Do', 'Lu', 'Ma', 'Me', 'Gi', 'Ve', 'Sa'],
                monthNames: [
                    'Gennaio',
                    'Febbraio',
                    'Marzo',
                    'Aprile',
                    'Maggio',
                    'Giugno',
                    'Luglio',
                    'Agosto',
                    'Settembre',
                    'Ottobre',
                    'Novembre',
                    'Dicembre'
                ],
                monthNamesShort: ['Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu', 'Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic'],
                today: 'Oggi',
                clear: 'Cancella',
                dateFormat: 'dd/mm/yy',
                weekHeader: 'Sett',
                firstDayOfWeek: 1,
                dateIs: 'La data è',
                dateIsNot: 'La data non è',
                dateBefore: 'La data è prima',
                dateAfter: 'La data è dopo',
                chooseYear: 'Scegli Anno',
                chooseMonth: 'Scegli Mese',
                chooseDate: 'Scegli Data',
                prevDecade: 'Decennio Precedente',
                nextDecade: 'Decennio Successivo',
                prevYear: 'Anno Precedente',
                nextYear: 'Anno Successivo',
                prevMonth: 'Mese Precedente',
                nextMonth: 'Mese Successivo',
                prevHour: 'Ora Precedente',
                nextHour: 'Ora Successiva',
                prevMinute: 'Minuto Precedente',
                nextMinute: 'Minuto Successivo',
                prevSecond: 'Secondo Precedente',
                nextSecond: 'Secondo Successivo',
                am: 'AM',
                pm: 'PM'
            }
        })
    ];

    return makeEnvironmentProviders(providers);
};
